import { ReactNode, useState } from "react";

import { Popover } from "antd";
import { LineStyleValue, MULTI_PRODUCT_LINE_STYLES } from "constants/chart.constants";
import styled from "styled-components";

import { LineStylePreview } from "./LineStylePreview";

interface LineStylePickerProps {
  currentStyle: LineStyleValue;
  onSelect: (style: LineStyleValue) => void;
  children: ReactNode;
}

export function LineStylePicker({
  currentStyle,
  onSelect,
  children
}: LineStylePickerProps) {
  const [open, setOpen] = useState(false);

  const handleSelect = (style: LineStyleValue) => {
    onSelect(style);
    setOpen(false);
  };

  const content = (
    <StyleGrid onClick={(e) => e.stopPropagation()}>
      {MULTI_PRODUCT_LINE_STYLES.map((style) => {
        const key = style === "solid" ? "solid" : style.join(",");
        const currentKey = currentStyle === "solid" ? "solid" : currentStyle.join(",");
        return (
          <StyleOption
            key={key}
            $active={key === currentKey}
            onClick={() => handleSelect(style)}>
            <LineStylePreview style={style} height={5} />
          </StyleOption>
        );
      })}
    </StyleGrid>
  );

  return (
    <Popover
      placement="bottom"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      content={content}
      overlayInnerStyle={{ padding: 4 }}>
      {children}
    </Popover>
  );
}

const StyleGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

const StyleOption = styled.div<{ $active: boolean }>`
  padding: 1px 4px;
  cursor: pointer;
  border-radius: var(--border-radius);
  color: ${({ $active }) => ($active ? "var(--color-primary)" : "var(--color-icon)")};

  &:hover {
    color: var(--color-text);
  }
`;
